import React from 'react';

const PrimarySubscriberDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Primary Subscriber Dashboard</h1>
              <p className="mt-2 text-sm text-gray-600">Welcome to the Primary Subscriber dashboard</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Empty content for now */}
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Dashboard Content</h3>
          <p className="text-gray-600">This dashboard is currently empty. Content will be added later.</p>
        </div>
      </div>
    </div>
  );
};

export default PrimarySubscriberDashboard;
